import script from "./pro_menu.vue?vue&type=script&setup=true&lang=js"
export * from "./pro_menu.vue?vue&type=script&setup=true&lang=js"

import "./pro_menu.vue?vue&type=style&index=0&id=159fe5ae&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159fe5ae"]])

export default __exports__